import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { EpbtFaQuickTransferService } from '../../services/epbt-fa-quick-transfer.service';
import { EpButtonType, EpEventService, EpButtonStyle } from '@epicor/kinetic';
import { WebServiceCallResult, BisTrackSettingsDepartmentUsage, BisTrackSettings, StockTransferSaleType, WebTrackUser, Computer, Branch } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaQuickTransferModel } from '../../models/epbt-fa-quick-transfer-model';
import { OrderStatus, OrderLineType, OrderSource, TransactionType, SaleType, ErrorStatus, PageNames, LocalStorageSaveTypes } from 'ep-bt-controls';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { EpbtFaQuickTransferSummaryProductsGridComponent } from '../epbt-fa-quick-transfer-summary-products-grid/epbt-fa-quick-transfer-summary-products-grid.component';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-transfer-summary',
  templateUrl: './epbt-fa-quick-transfer-summary.component.html',
  styleUrls: ['./epbt-fa-quick-transfer-summary.component.scss']
})

export class EpbtFaQuickTransferSummaryComponent implements OnInit {

  selectedQuickTransferDetails: any;
  sourceBranch: Branch;
  destinationBranch: Branch;
  saleType: string;
  date: string;
  quickTransferXml: string;
  linesXmlString: string;
  EpButtonStyle = EpButtonStyle;
  EpButtonType = EpButtonType;
  bistrackSettings: BisTrackSettings;
  webTrackUser: WebTrackUser;
  divVisible = false;

  @ViewChild(EpbtFaQuickTransferSummaryProductsGridComponent, {static: false}) quickTransferSummaryProductsGridComponent: EpbtFaQuickTransferSummaryProductsGridComponent;

  constructor(
    public datepipe: DatePipe,
    public route: Router,
    public quickTransferService: EpbtFaQuickTransferService,
    private productService: EpbtFaProductService,
    private faService: EpbtFieldAgentService,
    private location: Location) { }

  ngOnInit() {
    this.faService.getBisTrackSetting(bisTrackSetting => {
      this.bistrackSettings = bisTrackSetting;
    });
    this.faService.getWebTrackUser(webTrackRes => {
      this.webTrackUser = webTrackRes;
    });
    this.updateSummaryData();
  }

  updateSummaryData() {
    this.sourceBranch = this.quickTransferService.quickTransfer.sourceBranch ? this.quickTransferService.quickTransfer.sourceBranch : new Branch();

    this.destinationBranch = this.quickTransferService.quickTransfer.destBranch ? this.quickTransferService.quickTransfer.destBranch : new Branch();

    this.saleType = this.quickTransferService.quickTransfer.stockTransfer.saleType == StockTransferSaleType.Delivered ? this.quickTransferService.quickTransfer.stockTransfer.saleType : 'Will Call';
    this.date = this.quickTransferService.quickTransfer.stockTransfer.dateRequired ? this.quickTransferService.quickTransfer.stockTransfer.dateRequired.toString() : '';
  }

  updateSummaryGridData() {
    this.updateSummaryData();
    this.quickTransferSummaryProductsGridComponent.updateSummaryGridData();
  }

  quickTransferSummarySave() {
    if (this.allProductsHavePerID()) {
      const transfer = this.quickTransferService.quickTransfer;
      this.createQuickTransferObj(transfer);
      console.log(JSON.stringify(this.quickTransferXml), 'qtXml');
      console.log(this.linesXmlString, 'lineXml');
      this.quickTransferService.addQuickTransferXmlPost(this.quickTransferXml, (result: WebServiceCallResult) => {
        if (result) {
          if (result.error != null) {
            this.quickTransferService.successMessage = result.errorMessage;
          } else {
            this.quickTransferService.successMessage = 'Transfer number ' + result.result + ' has been saved in database';
          }
          this.divVisible = true;
          console.log(result, 'result');
        }
      });
    } else {
      this.faService.displayToastMessage('Summary', "One or more products do not have 'Input Per ID'. Please remove them from the list", ErrorStatus.Warning);
      return;
    }
  }

  private allProductsHavePerID(): boolean {
    let result = true;
    this.quickTransferService.quickTransfer.quickTransferLines.forEach(line => {
      if (!line.perID || line.perID == 0) {
        result = false;
        // break;
      }
    });
    return result;
  }

  createQuickTransferObj(transfer: EpbtFaQuickTransferModel) {

    transfer.stockTransfer.orderStatusID = OrderStatus.Saved;
    transfer.stockTransfer.branchId = transfer.sourceBranch.branchID;
    transfer.stockTransfer.toBranchId = transfer.destBranch.branchID;
    transfer.stockTransfer.currency = this.bistrackSettings.baseCurrency;
    transfer.stockTransfer.orderPlacementTypeID = this.bistrackSettings.defaultOrderPlacementType;
    transfer.stockTransfer.computerID = this.bistrackSettings.defaultComputerId;
    transfer.stockTransfer.dateRequired = transfer.stockTransfer.dateRequired;
    transfer.stockTransfer.dateTimeCreated = new Date();
    transfer.stockTransfer.dateTimeLastModified = new Date();
    transfer.stockTransfer.createdByID = this.webTrackUser.bisTrackUserId; // employee ID
    transfer.stockTransfer.userID = this.webTrackUser.bisTrackUserId; // employee ID
    transfer.stockTransfer.userName = this.webTrackUser.bisTrackUserName; // employee name

    switch (this.bistrackSettings.departmentUsage) {
      case BisTrackSettingsDepartmentUsage.None:
        transfer.stockTransfer.fromDepartmentID = 0;
        transfer.stockTransfer.toDepartmentID = 0;
        break;
      case BisTrackSettingsDepartmentUsage.TakenBy:
        transfer.stockTransfer.fromDepartmentID = this.webTrackUser.departmentID;
        transfer.stockTransfer.toDepartmentID = this.webTrackUser.departmentID;
        break;
      case BisTrackSettingsDepartmentUsage.SalesRep:
        transfer.stockTransfer.fromDepartmentID = this.bistrackSettings.defaultDepartmentUsageDepartment;
        transfer.stockTransfer.toDepartmentID = this.bistrackSettings.defaultDepartmentUsageDepartment;
        break;
      case BisTrackSettingsDepartmentUsage.Computer:
        this.quickTransferService.getComputer(transfer.sourceBranch.computerID, (result: Computer) => {
          if (result) {
            transfer.stockTransfer.fromDepartmentID = result.departmentID;
          }
        });
        this.quickTransferService.getComputer(transfer.destBranch.computerID, (result: Computer) => {
          if (result) {
            transfer.stockTransfer.toDepartmentID = result.departmentID;
          }
        });
        break;
      default:
        break;
    }

    transfer.stockTransfer.dateRequiredOption = this.bistrackSettings.defaultDateRequiredOption;
    // Update line status
    //     transfer.quickTransferLines.forEach(element => {
    //       element.

    // });

    //     foreach(QuickTransferLine line in transfer.Lines)
    //     {
    //       line.LineStatus = (OrderStatus)transfer.OrderStatusID;
    //       line.SaleType = transfer.SaleType;
    //       line.ProductId = line.Product.ProductId;
    //       line.LineType = (int)OrderLineType.ProductLine;
    //     }
    console.log(transfer);
    this.createQuickTransferXmlFile(transfer);
  }

  createQuickTransferXmlFile(transfer: EpbtFaQuickTransferModel) {

    this.quickTransferXml = '<OrderHeader>' +
      '<OrderID>' + transfer.stockTransfer.orderId + '</OrderID>' +
      '<OrderNumber>' + transfer.stockTransfer.orderNumber + '</OrderNumber>' +
      '<OrderType>' + TransactionType.Transfer + '</OrderType>' +
      '<OrderStatus>' + transfer.stockTransfer.orderStatusID + '</OrderStatus>' +
      // '<OrderStatus>' + 1 + '</OrderStatus>' +
      '<BranchID>' + transfer.stockTransfer.branchId + '</BranchID>' +
      '<ToBranchID>' + transfer.stockTransfer.toBranchId + '</ToBranchID>' +
      '<UserID>' + transfer.stockTransfer.userID + '</UserID>' +
      '<SaleType>' + this.getSaleType(transfer.stockTransfer.saleType) + '</SaleType>' +
      // '<SaleType>' + 1 + '</SaleType>' +
      '<OrderPlacementTypeID>' + transfer.stockTransfer.orderPlacementTypeID + '</OrderPlacementTypeID>' +
      '<DateRequired>' + this.datepipe.transform(transfer.stockTransfer.dateRequired, 'yyyy-MM-dd') + '</DateRequired>' +
      '<DateRequiredOption>' + transfer.stockTransfer.dateRequiredOption + '</DateRequiredOption>' +
      '<DateRequested>' + this.datepipe.transform(new Date(), 'yyyy-MM-dd') + '</DateRequested>' +
      '<CurrencyID>' + transfer.stockTransfer.currency.currencyId + '</CurrencyID>' +
      '<NoOfLines>' + transfer.quickTransferLines.length + '</NoOfLines>' +
      '<CreatedByID>' + transfer.stockTransfer.createdByID + '</CreatedByID>' +
      '<UserID>' + transfer.stockTransfer.userID + '</UserID>' +
      '<UserName>' + transfer.stockTransfer.userName + '</UserName>' +
      '<ComputerID>' + transfer.stockTransfer.computerID + '</ComputerID>' +
      '<OrderingBranchID>' + transfer.stockTransfer.branchId + '</OrderingBranchID>' +
      '<DepartmentID>' + transfer.stockTransfer.fromDepartmentID + '</DepartmentID>' +
      '<ToDepartmentID>' + transfer.stockTransfer.toDepartmentID + '</ToDepartmentID>' +
      '<OrderSource>' + OrderSource.Cloud + '</OrderSource>' + this.createLinesXmlFile(transfer);

    // console.log(JSON.stringify(this.quickTransferXml);
  }

  createLinesXmlFile(transfer): string {

    const lines = this.quickTransferService.quickTransfer.quickTransferLines;
    this.linesXmlString = '<Lines>';
    lines.forEach(element => {
      const quantityTally = element.quantityTally ? '<QuantityTally>' + element.quantityTally + '</QuantityTally>' : '<QuantityTally />';
      element.orderLineId = element.orderLineId ? element.orderLineId : 0;
      element.orderId = element.orderId ? element.orderId : 0;
      element.unitCostPrice = element.unitCostPrice ? element.unitCostPrice : 0;
      element.totalCost = element.totalCost ? element.totalCost : 0;
      element.inputPerID = element.inputPerID ? element.inputPerID : 0;
      const xmlString: string = '<Line>' +
        '<OrderLineID>' + element.orderLineId + '</OrderLineID>' +
        '<OrderID>' + element.orderId + '</OrderID>' +
        '<LineNumber>' + element.lineNumber + '</LineNumber>' +
        '<LineType>' + OrderLineType.ProductLine + '</LineType>' +
        // '<LineStatus>' + element.lineStatus + '</LineStatus>' +
        // '<LineStatus>' + 1 + '</LineStatus>' +
        '<LineStatus>' + transfer.stockTransfer.orderStatusID + '</LineStatus>' +
        '<SaleType>' + this.getSaleType(transfer.stockTransfer.saleType) + '</SaleType>' +
        '<ProductID>' + element.product.productId + '</ProductID>' +
        '<InputPerID>' + element.inputPerID + '</InputPerID>' +
        '<PerID>' + element.perID + '</PerID>' +
        '<Quantity>' + element.quantity.toFixed(8) + '</Quantity>' +
        quantityTally +
        '<UnitCostPrice>' + element.unitCostPrice + '</UnitCostPrice>' +
        '<TotalCost>' + element.totalCost.toFixed(4) + '</TotalCost>' +
        '</Line>';

      this.linesXmlString += xmlString;
    });
    this.linesXmlString += '</Lines></OrderHeader>';
    return this.linesXmlString;
  }

  doneClicked() {
    if (this.quickTransferService.fromDashbard) {
      this.route.navigate(['/home']);
    } else {
      if (this.productService.selectedProductItem) {
        localStorage.setItem(LocalStorageSaveTypes.ProIndex, '0');
        this.productService.fromPage = PageNames.ProductSearch;
        this.route.navigate(['/home/product/details/', this.productService.selectedProductItem.productId]);
      } else {
        this.route.navigate(['/home']);
      }
    }
    this.quickTransferService.clearQuickTransferData();
  }

  getSaleType(saleType): number {

    switch (saleType) {
      case StockTransferSaleType.CollectLater: return SaleType.CollectLater;
      case StockTransferSaleType.CollectNow: return SaleType.CollectNow;
      case StockTransferSaleType.Delivered: return SaleType.Delivered;
      case StockTransferSaleType.Direct: return SaleType.Direct;
      case StockTransferSaleType.Mixed: return SaleType.Mixed;
      case StockTransferSaleType.NotApplicable: return SaleType.NotApplicable;
      case StockTransferSaleType.UPS: return SaleType.UPS;
      default: return 0;
    }

  }

}
